<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Blocked Analyics
        <small></small>
      </h1>

    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
          <div class="col-md-8">
              <div class="form-group">
                  <div class='input-group date' id='datetimepicker1'>
                      <input type='text' class="form-control" />
                      <span class="input-group-addon">
                        <span class="glyphicon glyphicon-calendar"></span>
                    </span>
                  </div>
              </div>
          </div>
      </div>
      <br />
      <div>
          <iframe id="analytics"></iframe>
      </div>

    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import $ from 'jquery'
  import 'eonasdan-bootstrap-datetimepicker'

  export default {
    name: 'NonAnalytic',
    data: function () {
      return {
        link: '/data/a/a',
        datetime: '',
        role: 1,
        form: new Form({})
      }
    },
    computed: {
    },
    methods: {
      search: function () {
        if (this.datetime === '') {
          this.msg = 'Choose a date'
          return 0
        }
      },
      dateToString: function (date) {
        var day = date.getDate().toString()
        day = day.length === 1 ? '0' + day : day
        var month = (date.getMonth() + 1).toString()
        month = month.length === 1 ? '0' + month : month
        return month + day
      },
      decoded: function (encoded) {
        if (encoded === '') {
          return ''
        }
        try {
          return decodeURI(encoded)
        } catch (err) {
          return encoded
        }
      }
    },
    mounted: function () {
      this.role = this.$store.state.role
      var self = this
      this.datetime = this.dateToString(new Date())
      document.getElementById('analytics').src = this.link + this.datetime + '.html'
      if (this.role < 40) {
        this.$router.push('/dashboard')
      }
      window.$ = $
      $(document).ready(function () {
        $('#select-server').val($('#select-server option:first').val())
        self.server = $('#select-server option:first').val()

        $('#datetimepicker1').datetimepicker({
          // format: 'YYYY-MM-DD HH:mm',
          locale: 'sr',
          ignoreReadonly: true,
          useCurrent: true
        })
        .on('dp.show', function () {
          return $(this).data('DateTimePicker').defaultDate(new Date())
        })
        .on('dp.change', function (e) {
          self.msg = ''
          self.datetime = e.date.utc().local().format('MMDD')
          document.getElementById('analytics').src = self.link + self.datetime + '.html'
        })
      })
    }
  }
</script>

<style scoped>
    /* width */
  ::-webkit-scrollbar {
      width: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #555;
  }
  iframe {
      width: 100%;
      min-height: 80vh;
      height: 100%;
      border: none;
  }
  @media screen and (max-width: 992px) {
  }
  @media screen and (max-width: 768px) {
  }
  @media screen and (max-width: 480px) {
  }
</style>



// WEBPACK FOOTER //
// NonAnalytic.vue?bcf36738